import React from 'react';
import { Allocation, Problem } from '../solver/types';

interface Props {
  problem: Problem;
  alloc: Allocation;
}

// Diagrama de flujo orígenes → destinos. El grosor de cada flecha es
// proporcional a las unidades enviadas en la solución.
const FlowDiagram: React.FC<Props> = ({ problem, alloc }) => {
  const m = problem.sources.length;
  const n = problem.dests.length;

  const W = 460;
  const rowH = 56;
  const H = Math.max(m, n) * rowH + 40;
  const leftX = 90;
  const rightX = W - 90;

  const yFor = (idx: number, count: number) =>
    (H / (count + 1)) * (idx + 1);

  // Máxima asignación para escalar el grosor.
  let maxA = 1;
  for (let i = 0; i < m; i++)
    for (let j = 0; j < n; j++) {
      const a = alloc[i][j];
      if (a && a > maxA) maxA = a;
    }

  const edges: { i: number; j: number; a: number }[] = [];
  for (let i = 0; i < m; i++)
    for (let j = 0; j < n; j++) {
      const a = alloc[i][j];
      if (a && a > 0) edges.push({ i, j, a });
    }

  return (
    <div className="flow-wrap">
      <svg viewBox={`0 0 ${W} ${H}`} className="flow-svg" width="100%">
        {edges.map((e, k) => {
          const y1 = yFor(e.i, m);
          const y2 = yFor(e.j, n);
          const width = 1 + (e.a / maxA) * 9;
          const midX = (leftX + rightX) / 2;
          return (
            <g key={k}>
              <path
                d={`M ${leftX + 18} ${y1} C ${midX} ${y1}, ${midX} ${y2}, ${rightX - 18} ${y2}`}
                className="flow-edge"
                style={{ strokeWidth: width }}
                fill="none"
              />
              <text x={midX} y={(y1 + y2) / 2 - 4} className="flow-label">
                {e.a}
              </text>
            </g>
          );
        })}

        {problem.sources.map((s, i) => (
          <g key={`s${i}`}>
            <circle cx={leftX} cy={yFor(i, m)} r={16} className="flow-node src" />
            <text x={leftX} y={yFor(i, m) + 4} className="flow-node-label">
              {s}
            </text>
          </g>
        ))}
        {problem.dests.map((d, j) => (
          <g key={`d${j}`}>
            <circle cx={rightX} cy={yFor(j, n)} r={16} className="flow-node dest" />
            <text x={rightX} y={yFor(j, n) + 4} className="flow-node-label">
              {d}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
};

export default FlowDiagram;
